import { makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { styledBy } from '../../utils/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        color: (styledBy('ascent', theme.palette.ascents)),
        textAlign: ({ textAlign }) => textAlign,
        margin: ({ margin }) => margin,
        fontSize: ({ fontSize }) => fontSize,
        fontWeight: ({ fontWeight }) => fontWeight,
        opacity: ({ opacity }) => opacity
    }
}))


const Text = ({
    ascent = "primary",
    className,
    children,
    textAlign = 'left',
    margin = '',
    fontSize = 14,
    fontWeight = 400,
    opacity = 1,
    ...props
}) => {

    const classes = useStyles({ ascent, textAlign, margin, fontSize, fontWeight, opacity });

    return (
        <Typography className={clsx(classes.root, className)} {...props}>
            {children}
        </Typography>
    )
}

Text.propTypes = {

}

export default Text
